import ContactForm from "../../components/ContactForm/ContactForm";
export default function Contact() {
  return <ContactForm />;
}
